import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToTimePlayer',
})
export class SecondsToTimePlayerPipe implements PipeTransform {
  transform(time: number, showMinus: boolean = false): string {
    if (isNaN(time) || time <= 0) {
      return '00:00';
    }
    const minutes = Math.floor(time / 60);
    const hours = Math.floor(minutes / 60);
    const seconds = Math.floor(time % 60);
    if(minutes === 0 && hours === 0 && seconds === 0) return '00:00';
    return hours > 0
      ? `${showMinus? '-' : ''}${this.addZeroFormat(hours)}:${this.addZeroFormat(minutes % 60)}:${this.addZeroFormat(seconds)}`
      : `${showMinus? '-' : ''}${this.addZeroFormat(minutes)}:${this.addZeroFormat(seconds)}`;
  }

  addZeroFormat(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }
}
